// export const API_URL = process.env.REACT_APP_API_URL || '/api'
export const RECEIPT_API_URL = 'https://api.globalreceipt.ca/api/v1'
export const API_URL = process.env.REACT_APP_API_URL || '/api'
